import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { login } from '@/api/auth'
import type { LoginByCodeForm, UserInfo } from '@/types'

export const useUserStore = defineStore('user', () => {
  // State
  const token = ref<string>(localStorage.getItem('token') || '')
  const userInfo = ref<UserInfo | null>(null)

  // Getters
  const isLoggedIn = computed(() => !!token.value)
  const isSuperAdmin = computed(() => userInfo.value?.userType === 1)
  const isAgent = computed(() => userInfo.value?.userType === 2)
  const isMember = computed(() => userInfo.value?.userType === 3)
  const isStoreAdmin = computed(() => userInfo.value?.userType === 4)

  // Actions
  async function loginAction(form: LoginByCodeForm) {
    const res = await login(form)
    token.value = res.token
    localStorage.setItem('token', res.token)
    // 记住登录邮箱，令牌过期后用于自动重发验证码
    localStorage.setItem('loginEmail', form.email)
    return res
  }

  function logout() {
    token.value = ''
    userInfo.value = null
    localStorage.removeItem('token')
  }

  function setUserInfo(info: UserInfo) {
    userInfo.value = info
  }

  return {
    token,
    userInfo,
    isLoggedIn,
    isSuperAdmin,
    isAgent,
    isMember,
    isStoreAdmin,
    loginAction,
    logout,
    setUserInfo
  }
})
